<template>
  <flex-layout
    class="button h-100 pt-3 px-1"
    :class="isSelected ? 'selected' : ''"
    align="center"
    justify="center"
    direction="column"
    wrap
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    @focus="hover = true"
    @blur="hover = false"
    @click="goToRoute"
    @keyup.enter="goToRoute"
  >
    <base-icon class="icon mb-1" :stroke="hover || isSelected? 'primary':'white'" :name="props.icon"
               width="2rem" height="2rem"/>
    <base-text class="text mb-1" size="xs" :color="hover || isSelected? 'primary':'white'" no-wrap>
      {{ props.label }}
    </base-text>
  </flex-layout>
</template>

<script setup lang="ts">

import {defineProps, ref, computed} from 'vue';
import BaseText from '@/components/Texts/BaseText.vue';
import FlexLayout from '@/components/Layouts/FlexLayout.vue';
import BaseIcon from '@/components/Images/BaseIcon.vue';
import {useRouter, useRoute} from 'vue-router';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  badge: {
    type: String,
    required: false,
  },
  route: {
    type: String,
    required: false,
  },
});

const hover = ref(false);

const router = useRouter();
const route = useRoute();

const isSelected = computed(() => route.name === props.route);

function goToRoute() {
  if (props.route) router.push({name: props.route});
}
</script>

<style scoped>
.button {
  width: 100%;
  max-width: 105px;
  cursor: pointer;
  transition: .3s ease-in-out;
}

.button:hover {
  background: var(--accent);
}

.selected {
  background: var(--accent);
}

.img-hover {
  stroke: var(--primary) !important;
  fill: var(--primary) !important;
}

.icon {
  transition: .3s ease-in-out;
}

.text {
  transition: .3s ease-in-out;
}
</style>
